import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export interface DataActionCardInfo {
  Type: DataActionCardInfoType;
  Title: string;
  Subtitle?: string;
  DataIcon?: Icon;
  ActionIcon?: Icon;
  ActionIdentifier?: unknown;
  ActionIsFailed?: boolean;
}

export enum DataActionCardInfoType {
  Data = 'Data',
  Action = 'Action',
}

export enum DataActionFailedType {
  Error = 'error',
  Warning = 'warning',
}

export enum DataActionCardStyle {
  Primary = 'primary',
  Secondary = 'secondary',
}

export const DataActionInitTopWithInfo = 5;
export const DataActionInitTopWithoutInfo = 0;
